import { createAudience } from '../../fbApi/Audience';
import { getVideosFromPage } from '../../fbApi/Videos';
import { getCanvasesFromPage } from '../../fbApi/Canvas';
import { getPage } from '../../fbApi/Page';

export const buildAudience = async (data, token) => {
  const date = new Date();
  const currentDate = `${date.getMonth() +
    1}/${date.getDate()}/${date.getFullYear()}`;

  const parameters = {
    pixel_id: data.pixel_id,
    name: `${data.name} - ${currentDate}`,
    retention_days: data.retention_days,
    rule: data.rule,
    accountId: data.accountId,
    subtype: data.subtype,
    description: data.description,
    claim_objective: data.claim_objective,
    content_type: data.content_type,
    event_source_group: data.event_source_group,
    inclusions: data.inclusions,
    exclusions: data.exclusions,
    event_sources: data.event_sources
  };

  const result = await createAudience(parameters, token);
  return result;
};

export const generateDomesticAudience = async (data) => {
  const domesticAudience = {
    name: 'MasterCard > Automotive > In Market > Domestic Car ',
    retention_days: 0,
    accountId: data.accountId,
    subtype: 'CUSTOM',
    description:
      'Individuals with a high likelihood to purchase a domestic car',
    customer_file_source: 'USER_PROVIDED_ONLY'
  };

  const resultVideosAudience = await buildAudience(
    domesticAudience,
    data.token
  );
  return resultVideosAudience;
};

export const generateWebsiteAudience = async (data) => {
  const websiteAudience = {
    pixel_id: data.pixel,
    name: 'Site Traffic',
    retention_days: 30,
    rule: {
      inclusions: {
        operator: 'or',
        rules: [
          {
            event_sources: [
              {
                id: data.pixel,
                type: 'pixel'
              }
            ],
            filter: {
              operator: 'and',
              filters: [
                {
                  operator: 'or',
                  filters: [
                    {
                      operator: 'i_contains',
                      field: 'url',
                      value: ''
                    }
                  ]
                }
              ]
            },
            retention_seconds: 2592000
          }
        ]
      }
    },
    accountId: data.accountId
  };

  const resultWebsiteAudience = await buildAudience(
    websiteAudience,
    data.token
  );
  return resultWebsiteAudience;
};

export const generateVideoAudience = async (data) => {
  const videosResult = await getVideosFromPage(data.pageId, data.token);

  if (videosResult.error) {
    return videosResult;
  }

  const videosForPage = videosResult.data;

  const videosRule = [];
  const toDate = new Date();
  const fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - 30);
  videosForPage.forEach((video) => {
    const videoDate = video.updated_time
      ? new Date(video.updated_time)
      : new Date(video.created_time);
    if (videoDate >= fromDate && videoDate <= toDate) {
      videosRule.push({
        event_name: 'video_view_25_percent',
        object_id: video.id
      });
    }
  });

  const videosAudience = {
    pixel_id: data.pixel,
    name: 'Video Views',
    retention_days: 30,
    rule: JSON.stringify(videosRule),
    accountId: data.accountId,
    subtype: 'ENGAGEMENT'
  };

  const resultVideosAudience = await buildAudience(videosAudience, data.token);
  return resultVideosAudience;
};

export const generateCanvasAudience = async (data) => {
  const page = await getPage(data.pageId, data.token);
  const canvasesResult = await getCanvasesFromPage(
    data.pageId,
    page.access_token
  );

  if (canvasesResult.error) {
    return canvasesResult;
  }

  const canvasesForPage = canvasesResult.data;

  const canvasesRules = [];
  canvasesForPage.forEach((canvas) => {
    canvasesRules.push({
      type: 'canvas',
      id: canvas.id,
      owner_id: canvas.owner.id
    });
  });

  const canvasAudience = {
    pixel_id: data.pixel,
    name: 'Canvas Views',
    retention_days: 30,
    rule: {
      inclusions: {
        operator: 'or',
        rules: [
          {
            event_sources: canvasesRules,
            retention_seconds: 2592000,
            filter: {
              operator: 'and',
              filters: [
                {
                  field: 'event',
                  operator: 'eq',
                  value: 'instant_shopping_document_open'
                }
              ]
            }
          }
        ]
      }
    },
    accountId: data.accountId
  };

  const resultCanvasAudience = await buildAudience(canvasAudience, data.token);
  return resultCanvasAudience;
};

export const createLookalikeAudience = async (audienceData, token) => {
  const createAudienceResult = await createAudience(audienceData, token, true);
  return createAudienceResult;
};



// WEBPACK FOOTER //
// ./src/screens/AudienceBuilder/AudienceCreator.js